<div class="myinfo-redirection-body">
    <ng-container *ngIf="isRedirecting">
        <p><span class="emphasized">At the moment, we are redirecting you to the Myinfo Auth Screen...</span></p>
    </ng-container>
    <ng-container *ngIf="!isRedirecting">
        <p><span class="emphasized">Screen will close automatically in 5 seconds.</span></p>
        <p><span class="emphasized">Please close it manually if it doesn't.</span></p>
    </ng-container>
</div>
